import { Component, Input, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-lottie-file',
  templateUrl: './lottie-file.component.html',
  styleUrls: ['./lottie-file.component.scss']
})
export class LottieFile implements OnInit {
  @Input() path: string;

  options: AnimationOptions;

  constructor() {}

  ngOnInit(): void {
    this.options = {
      path: this.path,
    };
  }

  onAnimate(): void {
  }
}
